const Sizes = {
    xlgMin: 1400,
    lgMax: 1399,
    lgMin: 1200,
    mdMax: 1199,
    mdMin: 992,
    smMax: 991,
    smMin: 768,
    xsMax: 767,
    xsMin: 576,
    mlMax: 575,
    mlMin: 375,
};
const Media = {
    xlgMin: `(min-width: ${Sizes.xlgMin}px)`,
    lgMax: `(max-width: ${Sizes.lgMax}px)`,
    lgMin: `(min-width: ${Sizes.lgMin}px)`,
    mdMax: `(max-width: ${Sizes.mdMax}px)`,
    mdMin: `(min-width: ${Sizes.mdMin}px)`,
    smMax: `(max-width: ${Sizes.smMax}px)`,
    smMin: `(min-width: ${Sizes.smMin}px)`,
    xsMax: `(max-width: ${Sizes.xsMax}px)`,
    xsMin: `(min-width: ${Sizes.xsMin}px)`,
    mlMax: `(max-width: ${Sizes.mlMax}px)`,
    mlMin: `(min-width: ${Sizes.mlMin}px)`,
};
export { Sizes, Media };
